import React, { useEffect, useState } from "react";
import "../../views/styles.css";
import "bootstrap/dist/css/bootstrap.css";
import "components/customModal/modal.css"
// import ReactDragListView from 'react-drag-listview';
import "font-awesome/css/font-awesome.min.css";
import FadeIn from "react-fade-in";
import { useLoading, Rings } from "@agney/react-loading";
import Attribute from "./Attribute";
import './styles.css'
import CreatableSelect from "react-select/creatable";

const createOption = (label) => ({
    label,
    value: label.toLowerCase().replace(/\W/g, ""),
});


function Modal({ data, handleSave, handleClose, saveField, tags, tagList, setTags }) {
    // const [tags, setTags] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // const [tagList, setTagList] = useState([]);
    const [change, setChange] = useState(false);
    useEffect(() => {

    },[])
    
    const customStyles = {
        valueContainer: (provided, state) => ({
            ...provided,
            //  padding: '2px 8px',
            //  backgroundColor: "red",
            outline: 'none',
            outline: 'none',
            paddingTop: 0,
            marginTop: 0,
            // paddingBottom: '17px',
        }),
        // placeholder: (provided, state) => ({
        //     ...provided,
        //     //    padding: '2px 8px',
        //     //  backgroundColor: "red",
        //     outline: 'none',
        // }),
        control: base => ({
            ...base,
            border: "1px solid rgb(118, 118, 118)",
            boxShadow: 'none',
            // paddingTop: '2px'

        })

    }
    const handleChange = (newValue, actionMeta) => {
        setChange(true);
        console.group("Value Changed");


        console.groupEnd();
        setTags(newValue);
    };
    const handleCreate = (inputValue) => {
        setChange(true);
        setIsLoading(true);
        console.group("Option created");

        setTimeout(() => {
            const newOption = createOption(inputValue);

            console.groupEnd();
            setTags([...tags, newOption]);
            setIsLoading(false);
        }, 1000);
    };
    return (
        <>

            <div
                className="modal fadeIn"
                style={{
                    display: "block", zIndex: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0,0,0,0.3)',

                }}
                role="dialog"
                id="kwModal"

            >
                {/* modal start */}

                <FadeIn>
                    <div className="modal-dialog modal-dialog-centered kw-workflow-modal" role="document" style={{ justifyContent: 'center', paddingTop: '4%' }}>
                        <form className="cmodal modal-content" style={{
                            maxWidth: "600px", minHeight: '100px',
                            borderRadius: '12px', borderWidth: 0 ,maxHeight: '97vh'
                        }}
                            onSubmit={(e) => { e.preventDefault(); handleSave(); }}
                        >
                            <div className="m-header" style={{marginBottom:"10px"}}>
                                <span>{'Create Contact'}</span>
                                <span style={{ cursor: 'pointer' }} onClick={handleClose} >x</span>
                            </div>
                            <div id='cont-grid' style={{display:"grid", gridTemplateColumns:"50% 50%" ,overflow:"scroll", padding:"20px"}}>
                                {data && data.map((attr,i) =>{
                                    return attr.label == 'isProspect' || attr.label == 'isDeleted' ? <div className="contact-attr">
                                        <h6 >{attr.label}</h6>

                                        <select value={attr.value} onChange={(e) => saveField({ key: attr.key, value: e.target.value })}>
                                            <option value={false} >false</option>

                                            <option value={true} >true</option>

                                        </select>

                                    </div>:
                                     <Attribute key={i} saveField={saveField} attr={attr} />
                                     
                                     })}
                                <div className="contact-attr">
                                <h6>Tags</h6>
                                     <div style={{height:'45px'}}>
                                    <CreatableSelect
                                        isMulti={true}
                                        isClearable
                                        value={tags}
                                        placeholder={"Add.."}
                                        onChange={handleChange}
                                        onCreateOption={handleCreate}
                                        isDisabled={isLoading}
                                        isLoading={isLoading}
                                        options={tagList}
                                        styles={customStyles}

                                    />
                                    </div>
                                </div>

                            </div>
                  
                            <div className="m-footer">
                                <input
                                    type="submit"
                                    name="Save"
                                    style={{ margin_top: "2v", cursor: "pointer" }}
                                    className="add lg_btn primary"
                                    value="Save"
                                    onClick={() => {  }}
                                />
                                <span className="ml-5"></span>
                                <input
                                    type="submit"
                                    name="Cancel"
                                    style={{ margin_top: "2v", cursor: "pointer", marginLeft: '22px' }}
                                    className="ml-22 add lg_btn tertiary"
                                    value="Cancel"
                                    onClick={handleClose}
                                />
                            </div>
                        </form>
                    </div>
                </FadeIn>
            </div>



        </>
    );
}
export default Modal;

